<script lang="ts">
  import { getLocale, translate, type Variables } from "../domain/locale";

  export let label: string;
  export let vars: Variables = {};

  $: locale = getLocale();
  $: text = translate(locale, label, vars);
</script>

{text}
